import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FaArrowLeft, FaMoneyBillWave, FaPlus, FaTrash, FaCar, FaCalendarAlt, FaUser, FaChartLine } from 'react-icons/fa';

export default function EgresosAlquila({ user, goBack }) {
    const SUCURSAL_ID = 4; 

    const [egresos, setEgresos] = useState([]);
    const [vehiculos, setVehiculos] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    
    const [form, setForm] = useState({ descripcion: '', monto: '', vehiculo_id: '' });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const resEgresos = await axios.get(`https://api.alquilacarbolivia.com/api/egresos/${SUCURSAL_ID}`);
            setEgresos(resEgresos.data);

            const resVehiculos = await axios.get('https://api.alquilacarbolivia.com/api/vehiculos');
            setVehiculos(resVehiculos.data);
        } catch (error) {
            console.error(error);
            Swal.fire('Error', 'No se pudieron cargar los datos', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            await axios.post('https://api.alquilacarbolivia.com/api/egresos', {
                sucursal_id: SUCURSAL_ID,
                usuario_id: user.id,
                descripcion: form.descripcion,
                monto: form.monto,
                vehiculo_id: form.vehiculo_id || null
            });
            
            await Swal.fire({
                icon: 'success',
                title: '¡Registrado!',
                text: 'Gasto operativo guardado correctamente',
                confirmButtonColor: '#ee0979'
            });
            
            setShowModal(false);
            setForm({ descripcion: '', monto: '', vehiculo_id: '' });
            fetchData();
        } catch (error) {
            Swal.fire('Error', 'No se pudo guardar el gasto', 'error');
        }
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: '¿Eliminar este gasto?',
            text: 'Esta acción no se puede deshacer',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ee0979',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                await axios.delete(`https://api.alquilacarbolivia.com/api/egresos/${id}`);
                Swal.fire('Eliminado', 'El gasto ha sido eliminado', 'success');
                fetchData();
            } catch (error) {
                Swal.fire('Error', 'No se pudo eliminar el gasto', 'error');
            }
        }
    };

    const totalEgresos = egresos.reduce((acc, e) => acc + parseFloat(e.monto), 0);
    const gastosVehiculos = egresos.filter(e => e.marca).reduce((acc, e) => acc + parseFloat(e.monto), 0);
    const gastosGenerales = totalEgresos - gastosVehiculos;

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{minHeight: '100vh'}}>
                <div className="spinner-border" style={{
                    width: '3rem', 
                    height: '3rem',
                    color: '#ee0979'
                }}></div>
            </div>
        );
    }

    return (
        <div className="container-fluid p-0" style={{
            background: 'linear-gradient(to bottom, #f8f9fa 0%, #e9ecef 100%)', 
            minHeight: '100vh'
        }}>
            {/* HEADER MEJORADO */}
            <div className="shadow-lg" style={{
                background: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
                padding: '20px 30px'
            }}>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <button 
                            className="btn btn-light btn-sm me-3 shadow-sm" 
                            onClick={goBack}
                            style={{borderRadius: '20px', padding: '10px 20px'}}
                        >
                            <FaArrowLeft className="me-2"/> Volver
                        </button>
                        <div className="d-flex align-items-center">
                            <div className="bg-white bg-opacity-25 p-2 rounded-circle me-3">
                                <FaMoneyBillWave style={{fontSize: '1.8rem', color: 'white'}}/>
                            </div>
                            <div className="text-white">
                                <h3 className="m-0 fw-bold" style={{letterSpacing: '1px'}}>GASTOS OPERATIVOS</h3>
                                <small style={{opacity: 0.9}}>Rent A Car - Control de Egresos</small>
                            </div>
                        </div>
                    </div>
                    <button 
                        className="btn btn-light fw-bold shadow-lg" 
                        onClick={() => setShowModal(true)}
                        style={{
                            borderRadius: '25px',
                            padding: '12px 30px',
                            fontSize: '1rem',
                            border: 'none'
                        }}
                    >
                        <FaPlus className="me-2"/> Nuevo Gasto
                    </button>
                </div>
            </div>

            <div className="p-4">
                {/* ESTADÍSTICAS */}
                <div className="row mb-4 g-3">
                    <div className="col-md-4">
                        <div className="card border-0 shadow-lg" style={{
                            borderRadius: '20px',
                            background: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
                            color: 'white'
                        }}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <div style={{opacity: 0.9, fontSize: '0.9rem'}}>Total Gastos</div>
                                        <h2 className="fw-bold mb-0 mt-2">Bs. {totalEgresos.toFixed(2)}</h2>
                                    </div>
                                    <div className="bg-white bg-opacity-25 p-3 rounded-circle">
                                        <FaChartLine style={{fontSize: '2rem'}}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-4">
                        <div className="card border-0 shadow-sm" style={{
                            borderRadius: '20px',
                            background: 'white'
                        }}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <div className="text-muted" style={{fontSize: '0.9rem'}}>Gastos de Vehículos</div>
                                        <h3 className="fw-bold mb-0 mt-2" style={{color: '#667eea'}}>
                                            Bs. {gastosVehiculos.toFixed(2)}
                                        </h3>
                                    </div>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        padding: '12px',
                                        borderRadius: '50%'
                                    }}>
                                        <FaCar style={{fontSize: '1.5rem', color: 'white'}}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-4">
                        <div className="card border-0 shadow-sm" style={{
                            borderRadius: '20px',
                            background: 'white'
                        }}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <div className="text-muted" style={{fontSize: '0.9rem'}}>Gastos Generales</div>
                                        <h3 className="fw-bold mb-0 mt-2" style={{color: '#11998e'}}>
                                            Bs. {gastosGenerales.toFixed(2)}
                                        </h3>
                                    </div>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                        padding: '12px',
                                        borderRadius: '50%'
                                    }}>
                                        <FaMoneyBillWave style={{fontSize: '1.5rem', color: 'white'}}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* TABLA MEJORADA */}
                <div className="card border-0 shadow-lg" style={{borderRadius: '20px', overflow: 'hidden'}}>
                    <div className="card-header text-white border-0 py-3" style={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                    }}>
                        <h5 className="mb-0 fw-bold">📋 Registro de Gastos ({egresos.length})</h5>
                    </div>
                    
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                            <thead style={{background: '#f8f9fa'}}>
                                <tr>
                                    <th className="fw-bold py-3 px-4">
                                        <FaCalendarAlt className="me-2 text-muted"/> Fecha
                                    </th>
                                    <th className="fw-bold">Concepto</th>
                                    <th className="fw-bold">Vehículo Relacionado</th>
                                    <th className="fw-bold">
                                        <FaUser className="me-2 text-muted"/> Registrado por
                                    </th>
                                    <th className="fw-bold text-end">Monto</th>
                                    <th className="fw-bold text-center">Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                {egresos.map(e => (
                                    <tr key={e.id}>
                                        <td className="px-4">
                                            <span className="badge bg-light text-dark px-3 py-2" style={{borderRadius: '10px'}}>
                                                {new Date(e.fecha).toLocaleDateString('es-ES', { 
                                                    day: '2-digit', 
                                                    month: 'short',
                                                    year: 'numeric'
                                                })}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="fw-bold" style={{color: '#2d3748'}}>
                                                {e.descripcion}
                                            </div>
                                        </td>
                                        <td>
                                            {e.marca ? (
                                                <span className="badge px-3 py-2" style={{
                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    color: 'white',
                                                    borderRadius: '10px',
                                                    fontSize: '0.8rem'
                                                }}>
                                                    <FaCar className="me-1"/> {e.marca} {e.modelo} ({e.placa})
                                                </span>
                                            ) : (
                                                <span className="text-muted small">
                                                    <em>-- Gasto General --</em>
                                                </span>
                                            )}
                                        </td>
                                        <td>
                                            <span className="badge bg-light text-dark" style={{borderRadius: '10px'}}>
                                                {e.usuario}
                                            </span>
                                        </td>
                                        <td className="text-end">
                                            <span className="fw-bold" style={{
                                                fontSize: '1.1rem',
                                                color: '#ee0979'
                                            }}>
                                                - Bs. {parseFloat(e.monto).toFixed(2)}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            <button 
                                                className="btn btn-sm shadow-sm"
                                                onClick={() => handleDelete(e.id)}
                                                style={{
                                                    background: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '10px',
                                                    padding: '8px 15px'
                                                }}
                                            >
                                                <FaTrash/>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                {egresos.length === 0 && (
                                    <tr>
                                        <td colSpan="6" className="text-center py-5">
                                            <div className="text-muted">
                                                <FaMoneyBillWave style={{fontSize: '3rem', opacity: 0.3}} className="mb-3"/>
                                                <div>No hay gastos registrados</div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* MODAL MEJORADO */}
            {showModal && (
                <div className="modal d-block" style={{backgroundColor: 'rgba(0,0,0,0.8)'}}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg" style={{borderRadius: '25px'}}>
                            <div className="modal-header text-white border-0" style={{
                                background: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
                                borderRadius: '25px 25px 0 0'
                            }}>
                                <h5 className="modal-title fw-bold">
                                    <FaPlus className="me-2"/> Registrar Nuevo Gasto
                                </h5>
                                <button 
                                    className="btn-close btn-close-white" 
                                    onClick={() => setShowModal(false)}
                                ></button>
                            </div>
                            
                            <form onSubmit={handleSave}>
                                <div className="modal-body p-4">
                                    <div className="mb-3">
                                        <label className="fw-bold mb-2" style={{color: '#2d3748'}}>
                                            Descripción del Gasto *
                                        </label>
                                        <input 
                                            className="form-control border-2" 
                                            required 
                                            placeholder="Ej: Cambio de aceite, gasolina, limpieza..." 
                                            value={form.descripcion} 
                                            onChange={e => setForm({...form, descripcion: e.target.value})} 
                                            autoFocus
                                            style={{borderRadius: '15px', padding: '12px'}}
                                        />
                                    </div>
                                    
                                    <div className="mb-3">
                                        <label className="fw-bold mb-2 text-danger">
                                            Monto (Bs) *
                                        </label>
                                        <input 
                                            type="number" 
                                            step="0.50" 
                                            className="form-control border-2 border-danger" 
                                            required 
                                            placeholder="0.00"
                                            value={form.monto} 
                                            onChange={e => setForm({...form, monto: e.target.value})}
                                            style={{borderRadius: '15px', padding: '12px', fontSize: '1.1rem'}}
                                        />
                                    </div>
                                    
                                    {/* SELECTOR DE VEHÍCULOS */}
                                    <div className="p-3 rounded shadow-sm" style={{
                                        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
                                        border: '2px dashed #667eea'
                                    }}>
                                        <label className="fw-bold mb-2" style={{color: '#667eea'}}>
                                            <FaCar className="me-2"/> Vincular a Vehículo (Opcional)
                                        </label>
                                        <select 
                                            className="form-select border-2" 
                                            value={form.vehiculo_id} 
                                            onChange={e => setForm({...form, vehiculo_id: e.target.value})}
                                            style={{borderRadius: '15px', padding: '12px'}}
                                        >
                                            <option value="">-- Gasto General de Oficina --</option>
                                            {vehiculos.map(v => (
                                                <option key={v.id} value={v.id}>
                                                    🚗 {v.marca} {v.modelo} - {v.placa}
                                                </option>
                                            ))}
                                        </select>
                                        <small className="text-muted mt-2 d-block">
                                            Seleccione un vehículo si el gasto está relacionado con uno específico
                                        </small>
                                    </div>
                                </div>
                                
                                <div className="modal-footer border-0 bg-light" style={{borderRadius: '0 0 25px 25px'}}>
                                    <button 
                                        type="button" 
                                        className="btn btn-secondary px-4 fw-bold shadow-sm" 
                                        onClick={() => setShowModal(false)}
                                        style={{borderRadius: '15px'}}
                                    >
                                        Cancelar
                                    </button>
                                    <button 
                                        type="submit" 
                                        className="btn fw-bold px-4 shadow-sm"
                                        style={{
                                            background: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '15px'
                                        }}
                                    >
                                        <FaPlus className="me-2"/> Guardar Gasto
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');
                * {
                    font-family: 'Poppins', sans-serif;
                }
                
                .table-hover tbody tr:hover {
                    background-color: rgba(238, 9, 121, 0.05) !important;
                }
            `}</style>
        </div>
    );
}